import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../Store/Apis/BaseUrl";
// Components
import ErrorComponent from "../Partials/_ErrorComponent";

class RegisterComponent extends React.Component {
  constructor() {
    super();
    this.state = {
      hasError: false,
      loginCode: null,
      showSuccessMessage: false,
      errMsg: "",
      form: {
        email: "",
        password: "",
      },
    };
  }

  componentDidMount() {
    document.body.className = "animsition page-login-v2 layout-full page-dark";
    document.title = "Oncoustics | Register";
  }

  handleInputChange = (event) => {
    const form = { ...this.state.form };
    form[event.target.name] = event.target.value;
    this.setState({ form });
  };

  login = (e) => {
    e.preventDefault();
    axios
      .post(`${baseUrl}/auth/register/doctors`, this.state.form)
      .then((response) => {
        console.log("rsponse", response.data);
        let { success, message } = response.data;
        if (success) {
          this.setState({
            hasError: false,
            showSuccessMessage: true,
          });
        } else {
          this.setState({
            hasError: true,
            errMsg: [message],
          });
        }
      })
      .catch((err) => {
        this.setState({
          hasError: true,
        });
      });
    console.log("Heey");
  };

  render() {
    return (
      <div
        className="page"
        data-animsition-in="fade-in"
        data-animsition-out="fade-out"
      >
        <div className="page-content">
          <div className="page-brand-info">
            {/* <div className="brand">
              <img className="brand-img" src="logo.png" alt="..." />
              <h2 className="brand-text font-size-40">Oncoustics</h2>
            </div>
            <p className="font-size-20">
              Oncoustics is dedicated to improving productivity in clinical
              workflow and making ultrasound more widely available, accessible
              to non-experts and affordable for diagnostic imaging.
            </p> */}
          </div>
          <div className="page-login-main">
            <div className="auth-header ">
              <img className="auth-logo" src="/logo_full.png" alt="..." />
              {/* <h3 className="brand-text font-size-40">Oncoustics</h3> */}
            </div>
            <h3 className="auth-text">Register</h3>
            <p className="auth-register-description">
              Please use the email issued to you by Oncoustics to register your
              account.
            </p>
            {this.state.hasError && (
              <ErrorComponent errors={this.state.errMsg} />
            )}

            {!this.state.showSuccessMessage && (
              <>
                <form onSubmit={this.login}>
                  <div
                    className="form-group form-material floating auth-form-field"
                    data-plugin="formMaterial"
                  >
                    <input
                      type="text"
                      className="form-control empty"
                      id="inputEmail"
                      name="firstName"
                      onChange={this.handleInputChange}
                    />
                    <label className="floating-label" htmlFor="inputEmail">
                      First Name
                    </label>
                  </div>

                  <div
                    className="form-group form-material floating auth-form-field"
                    data-plugin="formMaterial"
                  >
                    <input
                      type="text"
                      className="form-control empty"
                      id="inputEmail"
                      name="lastName"
                      onChange={this.handleInputChange}
                    />
                    <label className="floating-label" htmlFor="inputEmail">
                      last name
                    </label>
                  </div>

                  <div
                    className="form-group form-material floating auth-form-field"
                    data-plugin="formMaterial"
                  >
                    <input
                      type="text"
                      className="form-control empty"
                      id="inputEmail"
                      name="country"
                      onChange={this.handleInputChange}
                    />
                    <label className="floating-label" htmlFor="inputEmail">
                      Country
                    </label>
                  </div>

                  <div
                    className="form-group form-material floating auth-form-field"
                    data-plugin="formMaterial"
                  >
                    <input
                      type="email"
                      className="form-control empty"
                      id="inputEmail"
                      name="email"
                      onChange={this.handleInputChange}
                    />
                    <label className="floating-label" htmlFor="inputEmail">
                      Email
                    </label>
                  </div>
                  <div
                    className="form-group form-material floating auth-form-field"
                    data-plugin="formMaterial"
                  >
                    <input
                      type="password"
                      className="form-control empty"
                      id="inputPassword"
                      name="password"
                      onChange={this.handleInputChange}
                    />
                    <label className="floating-label" htmlFor="inputPassword">
                      Password
                    </label>
                  </div>
                  <button type="submit" className="btn  btn-onc btn-login">
                    Next
                  </button>
                </form>
                <p className="auth-helper">
                  Already have an account?
                  <Link to="/login"> Sign In</Link>
                </p>
              </>
            )}
            {this.state.showSuccessMessage && (
              <>
                <h3 className="font-size-24">Sign Up</h3>
                <p>
                  Thank you, we will verifiy your account and send you
                  confirmation mail
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default RegisterComponent;
